import { ApiStrategyTemplate } from 'api/rtk-api'

import { EditStrategiesActions } from '../../../../modules/strategy-admin/state/edit-strategy-slice'
import { Errors } from '../../../../modules/tradebuilder-v2/util'
import { Attribute, FormItem, Label, NumberInput, ValidationMessage } from '../..'

type VixParameterInputProps = {
  actions: EditStrategiesActions
  errors: Errors
  strat: ApiStrategyTemplate
}

function round(val: number, pow: number) {
  const exp = 10 ** pow
  const res = Math.round(val * exp) / exp
  return res
}

export function VixParameterInput({ actions, errors, strat }: VixParameterInputProps) {
  return (
    <FormItem>
      <Label>Volatility index trigger</Label>
      <Attribute nameComponent="Trigger level">
        <NumberInput
          value={strat.volatilityIndexTriggerLevel === 0 ? '' : strat.volatilityIndexTriggerLevel}
          onChange={v => actions.setVolIndexTriggerLevel(Number(v.target.value))}
        />
      </Attribute>
      <Attribute nameComponent="Max allocation after trigger (%)">
        <NumberInput
          value={
            strat.shortCircuitMaxAllocation === 0
              ? ''
              : round(strat.shortCircuitMaxAllocation * 100, 2)
          }
          onChange={v => actions.setShortCircuitMaxAlloc(round(Number(v.target.value) / 100, 4))}
        />
      </Attribute>
      {(strat.strategyType === 'TIPP' || strat.strategyType === 'CPPI') && (
        <Attribute nameComponent="Reduced multiplier after trigger">
          <NumberInput
            value={
              strat.shortCircuitReducedMultiplier === 0 ? '' : strat.shortCircuitReducedMultiplier
            }
            onChange={v => actions.setShortCircuitReducedMultiplier(Number(v.target.value))}
          />
        </Attribute>
      )}
      <ValidationMessage errors={errors} fieldName="vol_index_trigger" />
      <ValidationMessage errors={errors} fieldName="short_circuit" />
      <ValidationMessage errors={errors} fieldName="reduced_multiplier" />
    </FormItem>
  )
}
